import React, { useEffect } from 'react';

export default function ReturnPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{
      maxWidth: '900px',
      margin: '40px auto',
      padding: '0 20px',
      lineHeight: '1.8',
      color: '#333',
      textAlign: 'left'
    }}>
      <h1 style={{ fontSize: '32px', marginBottom: '20px' }}>Return & Refund Policy</h1>
      <p style={{ color: '#666', marginBottom: '30px' }}>Last updated: {new Date().toLocaleDateString()}</p>
      
      <div style={{ fontSize: '15px', textAlign: 'left' }}>
        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>No Returns or Refunds</h2>
          <p style={{ marginBottom: '15px' }}>
            <strong>All sales are final.</strong> At this time, Bokeh does not accept returns, exchanges, or offer refunds for any products purchased through our website.
          </p>
          <p style={{ marginBottom: '15px' }}>
            We encourage you to carefully review your order, including product details, size, color, quantity, and shipping address, 
            before completing your purchase. Once an order is placed and payment is processed, it cannot be cancelled, returned, or refunded.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>Damaged or Defective Products</h2>
          <p style={{ marginBottom: '15px' }}>
            While we do not accept returns under normal circumstances, we understand that products may occasionally arrive damaged or defective due to shipping or manufacturing issues.
          </p>
          <p style={{ marginBottom: '15px' }}>
            If you receive a product that is damaged or defective, please contact us within <strong>48 hours of delivery</strong> at:
          </p>
          <div style={{ background: '#f9f9f9', padding: '20px', borderRadius: '5px', marginTop: '15px', marginBottom: '15px' }}>
            <p style={{ marginBottom: '8px' }}>Email: <a href="mailto:contact@bokehclo.com" style={{ color: '#000', textDecoration: 'underline' }}>contact@bokehclo.com</a></p>
          </div>
          <p style={{ marginBottom: '15px' }}>
            Your email must include:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Your order number</li>
            <li>A detailed description of the damage or defect</li>
            <li>Clear photos showing the damaged or defective product</li>
            <li>Photos of the packaging (if relevant)</li>
          </ul>
          <p style={{ marginBottom: '15px' }}>
            We will review your claim and determine the appropriate resolution at our sole discretion. This may include a replacement, 
            store credit, or other accommodation as we deem appropriate. Claims submitted after 48 hours of delivery may not be accepted.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>Wrong Item Shipped</h2>
          <p style={{ marginBottom: '15px' }}>
            If you receive an incorrect item (different from what you ordered), please contact us within <strong>48 hours of delivery</strong> at 
            <a href="mailto:contact@bokehclo.com" style={{ color: '#000', textDecoration: 'underline', margin: '0 4px' }}>contact@bokehclo.com</a> 
            with your order number and photos of the item received.
          </p>
          <p style={{ marginBottom: '15px' }}>
            We will investigate the issue and work to resolve it promptly. If our error is confirmed, we will arrange for the correct item 
            to be sent to you at no additional cost.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>Lost or Stolen Packages</h2>
          <p style={{ marginBottom: '15px' }}>
            Once a package has been marked as delivered by the shipping carrier, we cannot be held responsible for lost or stolen packages. 
            We recommend:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Tracking your package using the tracking number provided</li>
            <li>Arranging for someone to receive the package if you won't be home</li>
            <li>Requesting signature confirmation at checkout if available</li>
            <li>Checking with neighbors or building management</li>
          </ul>
          <p style={{ marginBottom: '15px' }}>
            If you believe your package was lost or stolen, please contact the shipping carrier directly using the tracking information 
            provided in your confirmation email. You may also file a claim with the carrier if applicable.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>Order Accuracy</h2>
          <p style={{ marginBottom: '15px' }}>
            You are responsible for ensuring that all information provided during checkout is accurate, including:
          </p>
          <ul style={{ paddingLeft: '20px', marginLeft: '0', marginBottom: '15px', lineHeight: '1.8' }}>
            <li>Product selection (style, size, color, quantity)</li>
            <li>Shipping address</li>
            <li>Contact information (email and phone number)</li>
          </ul>
          <p style={{ marginBottom: '15px' }}>
            We are not responsible for orders that are undeliverable or delayed due to incorrect or incomplete address information. 
            If a package is returned to us due to an incorrect address you provided, you may be responsible for additional shipping 
            costs to resend the package.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>Questions or Concerns</h2>
          <p style={{ marginBottom: '15px' }}>
            If you have any questions about this Return & Refund Policy or need assistance with an order, please contact us at:
          </p>
          <div style={{ background: '#f9f9f9', padding: '20px', borderRadius: '5px', marginTop: '15px' }}>
            <p style={{ marginBottom: '8px' }}><strong>Bokeh</strong></p>
            <p style={{ marginBottom: '8px' }}>Email: <a href="mailto:contact@bokehclo.com" style={{ color: '#000', textDecoration: 'underline' }}>contact@bokehclo.com</a></p>
            <p style={{ marginBottom: '8px' }}>Website: <a href="https://bokehclo.com" style={{ color: '#000', textDecoration: 'underline' }}>https://bokehclo.com</a></p>
          </div>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '22px', marginBottom: '15px', marginTop: '30px' }}>Changes to This Policy</h2>
          <p style={{ marginBottom: '15px' }}>
            We reserve the right to update or modify this Return & Refund Policy at any time. Any changes will be posted on this page 
            with an updated "Last updated" date. Your continued use of our website following any changes constitutes acceptance of the 
            updated policy.
          </p>
        </section>

        <section style={{ marginBottom: '30px', marginTop: '40px', padding: '20px', background: '#f0f0f0', borderRadius: '5px' }}>
          <p style={{ fontSize: '13px', color: '#666', fontStyle: 'italic', marginBottom: '0' }}>
            <strong>Important:</strong> By making a purchase on our website, you acknowledge and agree to this Return & Refund Policy. 
            Please read this policy carefully before placing an order.
          </p>
        </section>
      </div>
    </div>
  );
}

